// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__21kLd","header":"ReportDetails_header__1xl6x","title":"ReportDetails_title__3HaNx","left":"ReportDetails_left__1rznH"};